import { STATUSPAGE } from '@repo/ui';
import {
  DeleteActivityValidationUseCaseInterface,
  GetActivityByIdUseCaseInterface,
  GetAllGroupsUserUseCaseInterface,
  GetAllPersonValidatedActivitiesUseCaseInterface,
} from 'domain/usecases';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';

export const usePersonValidatedActivitiesTab = () => {
  const [groups, setGroups] = useState<GetAllGroupsUserUseCaseInterface.Result>(
    [],
  );
  const [validatedActivities, setValidatedActivities] =
    useState<GetAllPersonValidatedActivitiesUseCaseInterface.Result>([]);

  const [activity, setActivity] =
    useState<GetActivityByIdUseCaseInterface.Result>(null);

  const [loadingGroups, setLoadingGroups] = useState<boolean>(false);

  const [loadingValidatedActivities, setLoadingValidatedActivities] =
    useState<boolean>(false);

  const [requestStatus, setRequestStatus] = useState<STATUSPAGE>(
    STATUSPAGE.INITIAL,
  );

  const [loadingActivity, setLoadingActivity] = useState<boolean>(false);

  const [loadingDeleteActivityValidation, setLoadingDeleteActivityValidation] =
    useState<boolean>(false);

  const { groupsService, personService, activityService } = useService();

  const requestGetAllGroupsUser = useCallback(
    async (params: GetAllGroupsUserUseCaseInterface.Params) => {
      setLoadingGroups(true);

      try {
        const res = await groupsService.getAllGroupsUser(params);
        setGroups(res);
      } catch (err: unknown) {
        console.log(err);
      } finally {
        setLoadingGroups(false);
      }
    },
    [],
  );

  const requestGetAllPersonValidatedActivities = useCallback(
    async (params: GetAllPersonValidatedActivitiesUseCaseInterface.Params) => {
      setLoadingValidatedActivities(true);
      setRequestStatus(STATUSPAGE.LOADING);

      try {
        const res = await personService.getAllPersonValidatedActivities(params);
        setValidatedActivities(res);
        setRequestStatus(STATUSPAGE.DONE);
      } catch (err) {
        console.log(err);
        setValidatedActivities([]);
        setRequestStatus(STATUSPAGE.ERROR);
        notifyError(err.message || 'Erro ao buscar atividades validadas');
      } finally {
        setLoadingValidatedActivities(false);
      }
    },
    [],
  );

  const requestGetActivityById = useCallback(
    async (params: GetActivityByIdUseCaseInterface.Params) => {
      setLoadingActivity(true);

      try {
        const res = await activityService.getActivityById(params);
        setActivity(res);
      } catch (err: unknown) {
        console.log(err);
      } finally {
        setLoadingActivity(false);
      }
    },
    [],
  );

  const requestDeleteActivityValidation = useCallback(
    async (
      params: DeleteActivityValidationUseCaseInterface.Params,
      onSuccess: () => void,
    ) => {
      setLoadingDeleteActivityValidation(true);

      try {
        const res = await activityService.deleteActivityValidation(params);
        onSuccess();
        notifySuccess(res.message);
      } catch (err: unknown) {
        console.log(err);
      } finally {
        setLoadingDeleteActivityValidation(false);
      }
    },
    [],
  );

  return {
    groups,
    activity,
    requestStatus,
    loadingGroups,
    loadingActivity,
    validatedActivities,
    requestGetActivityById,
    requestGetAllGroupsUser,
    loadingValidatedActivities,
    loadingDeleteActivityValidation,
    requestDeleteActivityValidation,
    requestGetAllPersonValidatedActivities,
  };
};
